import { useTheme } from "@/context/ThemeContext";

// Theme-aware Recharts colors so in-app charts feel native in both light and dark.
// NOTE: client-facing proposal charts (components/proposal/charts.jsx) intentionally
// stay light — they render on a paper-like document preview and in printed PDFs.
export function useChartTheme() {
  const { theme } = useTheme();
  const dark = theme === "dark";
  return {
    dark,
    grid: dark ? "#233046" : "#E2E8F0",
    gridSoft: dark ? "#1b2740" : "#eef2f7",
    tick: dark ? "#94A3B8" : "#64748B",
    tickDim: dark ? "#8090a8" : "#94A3B8",
    axis: dark ? "#3a4a63" : "#94a3b8",
    line: dark ? "#5AA9FF" : "#003E87",
    bar: dark ? "#4d9fff" : "#003E87",
    total: dark ? "#CBD5E1" : "#0F172A",
    cursor: dark ? "rgba(148,163,184,0.12)" : "rgba(0,62,135,0.04)",
    contentStyle: {
      fontSize: 12,
      borderRadius: 8,
      background: dark ? "#111827" : "#ffffff",
      border: `1px solid ${dark ? "#233046" : "#E2E8F0"}`,
      color: dark ? "#F8FAFC" : "#0f172a",
      boxShadow: dark ? "0 6px 20px rgba(0,0,0,0.55)" : "0 6px 20px rgba(15,23,42,0.08)",
    },
    itemStyle: { color: dark ? "#F8FAFC" : "#0f172a" },
    labelStyle: { color: dark ? "#F8FAFC" : "#0f172a" },
  };
}
